import ItilGraph from "@/view/content/ItilGraph/ItilGraph.vue";
import CustomTable from "@/view/content/CustomTable/CustomTable.vue";
import dayjs from "dayjs";
import {
  GET_CRITICAL_INCIDENTS,
  GET_INCIDENTS_LAST_HALF_YEAR
} from "@/core/services/graphql/queries/service_management_report/belgium/queries";
import { INSTANCE_ENUM } from "@/core/constants.js";
import { OPERATOR_ENUM } from "../../../../../../../core/constants";

export default {
  components: {
    ItilGraph,
    CustomTable
  },
  name: "Incidents",
  data() {
    return {
      date_from: dayjs().toISOString().substr(0, 10),
      date_to: dayjs().subtract(6, "M").toISOString().substr(0, 10),
      incidents: {
        criticals: {
          pagination: {
            limit: -1
          },
          filters: {
            priority: {
              value: "1"
            },
            sys_created_on: {
              value: [
                dayjs().subtract(6, "M").toISOString().substr(0, 10),
                dayjs().subtract(0, "M").toISOString().substr(0, 10)
              ],
              operator: OPERATOR_ENUM.BETWEEN
            }
          }
        },
        last_half_year: {
          pagination: {
            limit: -1
          },
          filters: {
            sys_created_on: {
              value: [
                dayjs().subtract(6, "M").toISOString().substr(0, 10),
                dayjs().subtract(0, "M").toISOString().substr(0, 10)
              ],
              operator: OPERATOR_ENUM.BETWEEN
            }
          }
        },
        headers: [
          { text: "Number", value: "number" },
          { text: "Opened", value: "opened_at" },
          { text: "Priority", value: "priority.value" },
          { text: "Title", value: "short_description" },
          { text: "Updated", value: "sys_updated_on" },
          { text: "State", value: "state" },
          { text: "Configuration Item", value: "cmdb_ci" }
        ]
      },
      account_number: ""
    };
  },
  methods: {
    fetchData(loadObject) {
      this.date_from = loadObject.date_from;
      this.date_to = loadObject.date_to;
      this.incidents.last_half_year.filters.company = {
        value: loadObject.sys_id
      };
      this.incidents.criticals.filters.company = {
        value: loadObject.sys_id
      };
      this.incidents.last_half_year.filters.sys_created_on = {
        value: [this.date_from, this.date_to],
        operator: OPERATOR_ENUM.BETWEEN
      };
      this.incidents.criticals.filters.sys_created_on = {
        value: [this.date_from, this.date_to],
        operator: OPERATOR_ENUM.BETWEEN
      };
      this.$refs.itilTableIncidentCriticals.loadData({
        accountNumber: loadObject.account_number,
        filters: this.incidents.criticals.filters,
        headers: this.incidents.headers,
        instance: INSTANCE_ENUM.SNOW_GROUP,
        pagination: this.incidents.criticals.pagination,
        queryOptions: { display_value: true },
        queryString: GET_CRITICAL_INCIDENTS,
        reportType: "overview",
        tableName: "critical_incidents",
        title: "Criticals Incidents Last 6 Months",
        value: "incidents"
      });
      this.$refs.itilTableIncidentLast.loadData({
        accountNumber: loadObject.account_number,
        filters: this.incidents.last_half_year.filters,
        headers: this.incidents.headers,
        instance: INSTANCE_ENUM.SNOW_GROUP,
        pagination: this.incidents.last_half_year.pagination,
        queryOptions: { display_value: true },
        queryString: GET_INCIDENTS_LAST_HALF_YEAR,
        reportType: "overview",
        tableName: "incidents",
        title: "Incidents Last 6 Months",
        value: "incidents"
      });
      this.$refs.itilGraphIncident.fetchData({
        account_number: loadObject.account_number,
        sys_id: loadObject.sys_id,
        itil_type: "incidents",
        date_from: loadObject.date_from,
        date_to: loadObject.date_to
      });
    }
  }
};
